"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var POLL_INTERVAL_MS = 2000;
var POLL_MAX_DURATION_MS = 30 * 60 * 1000;
var ResetSchoolServiceAreaModalController = /** @class */ (function () {
    function ResetSchoolServiceAreaModalController($uibModalInstance, $interval, UsersModel, school, zones) {
        // UI state
        this.phase = "confirm";
        this.selectedZoneId = null;
        this.count = null;
        this.countError = null;
        this.loadingCount = false;
        this.confirmationText = "";
        this.kickoffInFlight = false;
        // progress state
        this.resetId = null;
        this.progress = { total: 0, processed: 0, failed: 0, percentage: 0 };
        this.failures = [];
        this.status = "idle";
        this.failureReason = null;
        this.pollTimedOut = false;
        this.pollPromise = null;
        this.pollStartedAt = 0;
        this.$uibModalInstance = $uibModalInstance;
        this.$interval = $interval;
        this.UsersModel = UsersModel;
        this.school = school;
        this.zones = zones || [];
        this.loadCount();
    }
    ResetSchoolServiceAreaModalController.prototype.loadCount = function () {
        var _this = this;
        this.loadingCount = true;
        this.count = null;
        this.countError = null;
        this.confirmationText = "";
        var zoneId = this.selectedZoneId == null ? undefined : this.selectedZoneId;
        this.UsersModel.getSchoolServiceAreaResetCount(this.school.id, zoneId)
            .then(function (response) {
            _this.count = response.count;
        })
            .catch(function (err) {
            // Do not silently coerce to 0 — that looked indistinguishable from a
            // legitimately empty filter in Tim's QA repro (AE-670) and hid a 422
            // from the API. Surface the error so the admin sees something is up.
            _this.count = null;
            _this.countError =
                (err && err.data && err.data.message) ||
                    "Could not load the student count. Please try again.";
        })
            .finally(function () {
            _this.loadingCount = false;
        });
    };
    ResetSchoolServiceAreaModalController.prototype.isValid = function () {
        return (!this.loadingCount &&
            this.count !== null &&
            this.count > 0 &&
            this.confirmationText === "RESET");
    };
    ResetSchoolServiceAreaModalController.prototype.confirm = function () {
        var _this = this;
        if (!this.isValid()) {
            return;
        }
        this.kickoffInFlight = true;
        var zoneId = this.selectedZoneId == null ? undefined : this.selectedZoneId;
        this.UsersModel.bulkResetSchoolStudentsServiceArea(this.school.id, zoneId)
            .then(function (response) {
            _this.resetId = response.reset_id;
            _this.progress = {
                total: response.count,
                processed: 0,
                failed: 0,
                percentage: 0,
            };
            _this.status = "pending";
            _this.phase = "progress";
            _this.startPolling();
        })
            .catch(function (err) {
            _this.failureReason =
                (err && err.data && err.data.message) ||
                    "Failed to start the reset. Please try again.";
            _this.phase = "failed";
        })
            .finally(function () {
            _this.kickoffInFlight = false;
        });
    };
    ResetSchoolServiceAreaModalController.prototype.retry = function () {
        this.phase = "confirm";
        this.confirmationText = "";
        this.failureReason = null;
        this.failures = [];
        this.loadCount();
    };
    ResetSchoolServiceAreaModalController.prototype.startPolling = function () {
        var _this = this;
        this.pollStartedAt = Date.now();
        this.pollTimedOut = false;
        this.pollOnce();
        this.pollPromise = this.$interval(function () { return _this.pollOnce(); }, POLL_INTERVAL_MS);
    };
    ResetSchoolServiceAreaModalController.prototype.pollOnce = function () {
        var _this = this;
        if (this.resetId === null) {
            this.stopPolling();
            return;
        }
        if (Date.now() - this.pollStartedAt > POLL_MAX_DURATION_MS) {
            this.pollTimedOut = true;
            this.stopPolling();
            return;
        }
        this.UsersModel.getSchoolServiceAreaResetStatus(this.school.id, this.resetId).then(function (response) {
            _this.status = response.status;
            _this.progress = response.progress;
            _this.failureReason = response.failure_reason;
            _this.failures = response.failures || [];
            if (response.status === "completed") {
                _this.stopPolling();
                _this.phase = "done";
            }
            else if (response.status === "failed") {
                _this.stopPolling();
                _this.phase = "failed";
            }
        });
    };
    ResetSchoolServiceAreaModalController.prototype.stopPolling = function () {
        if (this.pollPromise) {
            this.$interval.cancel(this.pollPromise);
            this.pollPromise = null;
        }
    };
    ResetSchoolServiceAreaModalController.prototype.cancel = function () {
        this.stopPolling();
        this.$uibModalInstance.dismiss("cancel");
    };
    ResetSchoolServiceAreaModalController.prototype.closeWhileRunning = function () {
        this.stopPolling();
        this.$uibModalInstance.close({
            status: "running",
            reset_id: this.resetId,
        });
    };
    ResetSchoolServiceAreaModalController.prototype.closeDone = function () {
        this.stopPolling();
        this.$uibModalInstance.close({
            status: "completed",
            processed: this.progress.processed,
            failed: this.progress.failed,
        });
    };
    return ResetSchoolServiceAreaModalController;
}());
ResetSchoolServiceAreaModalController.$inject = [
    "$uibModalInstance",
    "$interval",
    "UsersModel",
    "school",
    "zones",
];
exports.default = ResetSchoolServiceAreaModalController;
